/* ga-ads-earth20 — CRO for Google Shopping / Ads landings (2026-08-15) */
(function () {
  /* Match Shopify EARTH20 cents: floor(price_cents * 0.2002) */
  var RATE = 0.2002;
  var fetchingCart = false;
  var fetchPatched = false;
  var xhrPatched = false;
  var onetimeClicked = false;
  var strippedOnLoad = false;

  function hasPaidCookie() {
    return /(?:^|; )ga_paid_ads=1(?:;|$)/.test(document.cookie);
  }

  function markPaid() {
    try {
      sessionStorage.setItem("ga_paid_ads", "1");
    } catch (e) {}
    document.cookie = "ga_paid_ads=1; path=/; max-age=86400; SameSite=Lax";
    document.documentElement.classList.add("ga-paid-ads");
  }

  function isPaid() {
    try {
      if (sessionStorage.getItem("ga_paid_ads") === "1" || hasPaidCookie()) {
        markPaid();
        return true;
      }
      var p = new URLSearchParams(location.search);
      var paid = !!(
        p.get("gclid") ||
        p.get("gbraid") ||
        p.get("wbraid") ||
        p.get("utm_medium") === "product_sync" ||
        (p.get("utm_source") === "google" &&
          (p.get("utm_medium") === "cpc" || p.get("utm_medium") === "ppc"))
      );
      if (paid) {
        markPaid();
        return true;
      }
      return false;
    } catch (e) {
      return false;
    }
  }

  function money(n) {
    return "$" + n.toFixed(2);
  }

  function parseMoney(t) {
    var m = String(t).replace(/[^0-9.]/g, "");
    var n = parseFloat(m);
    return isFinite(n) ? n : 0;
  }

  function saleOf(orig) {
    var cents = Math.round(orig * 100);
    var off = Math.floor(cents * RATE);
    return (cents - off) / 100;
  }

  function walkRoots(node, cb) {
    if (!node) return;
    cb(node);
    var els = node.querySelectorAll ? node.querySelectorAll("*") : [];
    for (var i = 0; i < els.length; i++) {
      if (els[i].shadowRoot) walkRoots(els[i].shadowRoot, cb);
    }
  }

  function hideComparePills() {
    document.querySelectorAll("a").forEach(function (a) {
      if (a.classList.contains("ga-hide-compare")) return;
      var t = (a.textContent || "").replace(/\s+/g, " ").trim();
      if (
        /compare all (multi-surface|laundry)/i.test(t) ||
        /^🔍\s*Compare all/i.test(t)
      ) {
        a.classList.add("ga-hide-compare");
      }
    });
  }

  function suppressPaidPopups() {
    if (!isPaid()) return;
    document.documentElement.classList.add("ga-paid-ads");
    var nodes = document.querySelectorAll(
      ".popup--newsletter, #modal-ga_newsletter_popup, #newsletter-ga_newsletter_popup, #tidio-chat, #tidio-chat-code"
    );
    nodes.forEach(function (el) {
      el.style.display = "none";
      el.setAttribute("aria-hidden", "true");
    });
    document.querySelectorAll("a").forEach(function (a) {
      var t = (a.textContent || "").replace(/\s+/g, " ");
      if (!/refer 2 friends/i.test(t)) return;
      var host = a.parentElement;
      var hostText = host ? (host.textContent || "").replace(/\s+/g, " ").trim() : "";
      if (host && hostText.length < t.length + 48) {
        host.style.display = "none";
      } else {
        a.style.display = "none";
      }
    });
    try {
      if (window.tidioChatApi && window.tidioChatApi.hide) {
        window.tidioChatApi.hide();
      }
    } catch (e) {}
  }

  function showEarth20Prices() {
    if (!isPaid()) return;
    document.querySelectorAll("[data-js-product-price-original]").forEach(function (el) {
      var orig = parseMoney(el.getAttribute("data-ga-list") || el.textContent);
      if (!orig || orig < 5) return;
      var sale = saleOf(orig);
      if (sale >= orig) return;
      el.setAttribute("data-ga-earth20", "1");
      el.setAttribute("data-ga-list", String(orig));
      if (el.textContent.replace(/\s+/g, " ").trim() !== money(sale)) {
        el.textContent = money(sale);
      }
      var wrap = el.closest(".product-price");
      if (!wrap) return;
      var cmp = wrap.querySelector("[data-js-product-price-compare]");
      if (cmp) {
        cmp.innerHTML = "<span>" + money(orig) + "</span>";
      }
      var host = wrap.parentNode;
      if (host && !host.querySelector(".ga-earth20-note") && !document.querySelector(".ga-earth20-note")) {
        var note = document.createElement("span");
        note.className = "ga-earth20-note";
        note.textContent = laundryOffer(sale);
        host.insertBefore(note, wrap.nextSibling);
      }
    });
  }

  function injectOfferBar() {
    if (!isPaid()) return;
    var btn = document.querySelector(
      "[data-js-product-add-to-cart], button[name='add'], .add-to-cart"
    );
    if (!btn || !btn.parentNode) return;
    var origEl = document.querySelector("[data-js-product-price-original]");
    var orig = parseMoney(
      (origEl && (origEl.getAttribute("data-ga-list") || origEl.textContent)) || "12.99"
    );
    if (!orig || orig < 5) orig = 12.99;
    var sale = saleOf(orig);
    var bar = document.querySelector(".ga-earth20-bar");
    if (!bar) {
      bar = document.createElement("div");
      bar.className = "ga-earth20-bar";
      btn.parentNode.insertBefore(bar, btn);
    }
    bar.textContent = laundryOffer(sale);
  }

  function laundryOffer(sale) {
    var laundry = /\/products\/(laundry-sheets|eco-laundry)/i.test(location.pathname);
    if (laundry && sale) {
      return money(sale / 60) + " a load · free U.S. shipping · 30-day guarantee";
    }
    return "Free U.S. shipping · 30-day guarantee";
  }

  function clearSellingPlanInputs(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('input[name="selling_plan"], input[name="selling-plan"]').forEach(function (el) {
      el.value = "";
      el.setAttribute("value", "");
      el.disabled = true;
    });
  }

  function sellingPlanStillSet() {
    var found = false;
    document.querySelectorAll('input[name="selling_plan"], input[name="selling-plan"]').forEach(function (el) {
      if (el.value) found = true;
    });
    return found;
  }

  function forceRechargeOnetime() {
    if (onetimeClicked && !sellingPlanStillSet()) return;
    walkRoots(document, function (root) {
      var nodes = root.querySelectorAll("button, [role='radio'], [role='option'], label, div, span");
      for (var i = 0; i < nodes.length; i++) {
        var t = (nodes[i].textContent || "").replace(/\s+/g, " ").trim();
        if (/^one-time$/i.test(t) || /^one-time purchase$/i.test(t)) {
          try {
            nodes[i].click();
            onetimeClicked = true;
          } catch (e) {}
          return;
        }
      }
      var alt = root.querySelector(
        '[data-purchase-option="onetime"], .rc-purchase-option--onetime, [part*="onetime"]'
      );
      if (alt) {
        try {
          alt.click();
          onetimeClicked = true;
        } catch (e) {}
      }
    });
  }

  function stripSellingPlanFromBody(body) {
    if (!body) return body;
    try {
      if (typeof body === "string" && body.trim().charAt(0) === "{") {
        var j = JSON.parse(body);
        delete j.selling_plan;
        if (Array.isArray(j.items)) {
          j.items.forEach(function (it) {
            delete it.selling_plan;
          });
        }
        return JSON.stringify(j);
      }
      if (typeof FormData !== "undefined" && body instanceof FormData) {
        body.delete("selling_plan");
        body.delete("selling-plan");
        return body;
      }
    } catch (e) {}
    return body;
  }

  function patchFetch() {
    if (fetchPatched || !window.fetch) return;
    fetchPatched = true;
    var orig = window.fetch;
    window.fetch = function (input, init) {
      var url = "";
      try {
        url = typeof input === "string" ? input : input && input.url ? input.url : "";
      } catch (e) {}
      var isCartAdd = /\/cart\/add/i.test(url);
      if (isPaid() && isCartAdd && init && init.body) {
        init = Object.assign({}, init);
        init.body = stripSellingPlanFromBody(init.body);
      }
      var p = orig.apply(this, arguments);
      var removingLine = false;
      try {
        var reqBody = init && init.body;
        if (typeof reqBody === "string") {
          removingLine = /"quantity"\s*:\s*0\b/.test(reqBody);
        }
      } catch (e) {}
      if (isPaid() && /\/cart\/(add|change|update)/i.test(url) && !fetchingCart && !removingLine) {
        return p.then(function (res) {
          stripCartSubscriptions();
          return res;
        });
      }
      return p;
    };
  }

  function patchXHR() {
    if (xhrPatched || !window.XMLHttpRequest) return;
    xhrPatched = true;
    var open = XMLHttpRequest.prototype.open;
    var send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this._gaUrl = url || "";
      return open.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function (body) {
      if (isPaid() && /\/cart\/add/i.test(String(this._gaUrl || "")) && body) {
        body = stripSellingPlanFromBody(body);
      }
      return send.call(this, body);
    };
  }

  function stripCartSubscriptions() {
    if (!isPaid() || fetchingCart) return;
    fetchingCart = true;
    window
      .fetch("/cart.js")
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var items = (cart.items || []).filter(function (it) {
          return it.selling_plan_allocation || it.selling_plan;
        });
        var chain = Promise.resolve();
        items.forEach(function (it) {
          chain = chain.then(function () {
            return window.fetch("/cart/change.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                id: it.key,
                quantity: it.quantity,
                selling_plan: "",
              }),
            });
          });
        });
        return chain.then(function () {
          if (items.length) {
            document.documentElement.dispatchEvent(
              new CustomEvent("cart:refresh", { bubbles: true })
            );
            document.documentElement.dispatchEvent(
              new CustomEvent("cart:updated", { bubbles: true })
            );
          }
        });
      })
      .catch(function () {})
      .then(function () {
        fetchingCart = false;
      });
  }

  function onSubmit(e) {
    if (!isPaid()) return;
    var form = e.target;
    if (!form || !form.getAttribute) return;
    var action = form.getAttribute("action") || "";
    if (action.indexOf("/cart/add") === -1) return;
    clearSellingPlanInputs(form);
  }

  function onAddClick(e) {
    if (!isPaid()) return;
    var btn = e.target && e.target.closest
      ? e.target.closest("[data-js-product-add-to-cart], button[name='add'], .add-to-cart")
      : null;
    if (!btn) return;
    clearSellingPlanInputs(document);
    forceRechargeOnetime();
  }

  function run() {
    hideComparePills();
    suppressPaidPopups();
    showEarth20Prices();
    injectOfferBar();
    var laundry = /\/products\/(laundry-sheets|eco-laundry)/i.test(location.pathname);
    if (isPaid() || laundry) {
      forceRechargeOnetime();
      clearSellingPlanInputs(document);
    }
    if (isPaid()) {
      patchFetch();
      patchXHR();
      if (!strippedOnLoad) {
        strippedOnLoad = true;
        stripCartSubscriptions();
      }
    }
  }

  document.addEventListener("submit", onSubmit, true);
  document.addEventListener("click", onAddClick, true);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }

  [400, 1200, 2500].forEach(function (ms) {
    setTimeout(run, ms);
  });

  var scheduled = false;
  new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () {
      scheduled = false;
      run();
    }, 200);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
